module.exports = __webpack_public_path__ + "static/media/icon-podcast.33825586.webp";